<div *ngIf="applicableWorkflowPermissions != null && awDetails != null && !readOnlyMode" class="stage-approval-section"
    fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
    <p style="color: black;" *ngIf="!stageCompleted && loggedInUsersRole != 1 && loggedInUsersRole != 0">
        {{awDetails?.TemplateName}}: {{awDetails?.ActiveStageName}}</p>
    <button *ngIf="!stageCompleted && loggedInUsersRole != 1 && loggedInUsersRole != 0" mat-raised-button
        style="font-weight: bold;" class="mark_complete_btn" (click)="markStageAsComplete()">
        <mat-icon>check_circle_outline</mat-icon>
        Mark Complete
    </button>

    <div *ngIf="stageCompleted" class="stage_status_container">
        <mat-icon class="completed-check-circle">check_circle</mat-icon>
        <p>Completed!</p>
    </div>
</div>
<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
    <!-- page title -->
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
        <h1 class="mt-18">Offer Management</h1>
        <div fxLayout="row" class="arrows">
            <mat-button-toggle-group #status="matButtonToggleGroup" [value]="selectedVal"
                (change)="onValChange(status.value)" multiple class="multiple-toggle-btns arrows">
                <mat-button-toggle title="View All Approved" value="Approved"
                    class="nextButtons statusAPPROVED"><fa-icon *ngIf="isSelected(viewModel, 'Approved')"
                        [icon]="['fas', 'check']"></fa-icon>
                    <div class="number-text"><span class="number">{{statusCount.Approved| number: '3.0-0'}}</span>
                        <br />Approved
                    </div>
                </mat-button-toggle>
                <mat-button-toggle title="View All Pending" value="Pending" class="nextButtons statusPENDING"><fa-icon
                        *ngIf="isSelected(viewModel, 'Pending')" [icon]="['fas', 'check']"></fa-icon>
                    <div class="number-text"><span class="number">{{statusCount.Pending| number: '3.0-0'}}</span> <br />
                        Pending</div>
                </mat-button-toggle>
                <mat-button-toggle title="View All Suppressed" value="Suppressed"
                    class="nextButtons statusSUPPRESSED"><fa-icon *ngIf="isSelected(viewModel, 'Suppressed')"
                        [icon]="['fas', 'check']"></fa-icon>
                    <div class="number-text"><span class="number">{{statusCount.Suppressed | number: '3.0-0'}}</span>
                        <br /> Suppressed
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>

    <h2>{{viewModel.event.EventName}}</h2>
    <form class="actions-bar" [formGroup]="filtersForm" novalidate>

        <!-- actions bar -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start"
            class="toolbar">
            <button *ngIf="!readOnlyMode" appAuthorizeControl="edit||offermang" type="button" mat-raised-button
                color="accent" matTooltip="Add new record" [matMenuTriggerFor]="RecordType"
                queryParamsHandling="preserve">
                <fa-icon [icon]="['fas', 'plus']"></fa-icon> Create New <fa-icon style="padding-left: 4px;"
                    [icon]="['fas', 'caret-down']"></fa-icon>
            </button>
            <mat-menu #RecordType="matMenu" class="actions-bar-dropdown">
                <button class="ml-23" mat-menu-item matTooltip="Add new Offer" [routerLink]="[0, 'details']"
                    [queryParamsHandling]="'preserve'">Offer</button>
                <button class="ml-23" mat-menu-item matTooltip="Add New Offer Group"
                    (click)="navigateOfferGroup()">Offer
                    Group</button>
                <button class="ml-23" mat-menu-item matTooltip="Add new Promo"
                    [routerLink]="[0, 'promos','promodetails']" [queryParamsHandling]="'preserve'">Promo</button>
            </mat-menu>


            <mat-menu #menu="matMenu" class="mat-dropdown-menu">
                <button type="button" mat-menu-item
                    [matMenuTriggerFor]="Download"><mat-icon>arrow_circle_down</mat-icon>Download</button>
                <button class="align-middle" type="button" mat-menu-item (click)="ExportSelectedGalleyProof()"
                    [matMenuTriggerFor]="GalleyProof">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.5 9.5C14.0417 9.5 13.6771 9.36458 13.4062 9.09375C13.1354 8.82292 13 8.45833 13 8V6.5C13 6.04167 13.1354 5.67708 13.4062 5.40625C13.6771 5.13542 14.0417 5 14.5 5H15.5C15.9583 5 16.3229 5.13542 16.5938 5.40625C16.8646 5.67708 17 6.04167 17 6.5V8C17 8.45833 16.8646 8.82292 16.5938 9.09375C16.3229 9.36458 15.9583 9.5 15.5 9.5H14.5ZM9.5 9.5C9.04167 9.5 8.67708 9.36458 8.40625 9.09375C8.13542 8.82292 8 8.45833 8 8V6.5C8 6.04167 8.13542 5.67708 8.40625 5.40625C8.67708 5.13542 9.04167 5 9.5 5H10.5C10.9583 5 11.3229 5.13542 11.5938 5.40625C11.8646 5.67708 12 6.04167 12 6.5V8C12 8.45833 11.8646 8.82292 11.5938 9.09375C11.3229 9.36458 10.9583 9.5 10.5 9.5H9.5ZM4.5 9.5C4.04167 9.5 3.67708 9.36458 3.40625 9.09375C3.13542 8.82292 3 8.45833 3 8V6.5C3 6.04167 3.13542 5.67708 3.40625 5.40625C3.67708 5.13542 4.04167 5 4.5 5H5.5C5.95833 5 6.32292 5.13542 6.59375 5.40625C6.86458 5.67708 7 6.04167 7 6.5V8C7 8.45833 6.86458 8.82292 6.59375 9.09375C6.32292 9.36458 5.95833 9.5 5.5 9.5H4.5ZM4.5 15C4.04167 15 3.67708 14.8646 3.40625 14.5938C3.13542 14.3229 3 13.9583 3 13.5V12C3 11.5417 3.13542 11.1771 3.40625 10.9062C3.67708 10.6354 4.04167 10.5 4.5 10.5H5.5C5.95833 10.5 6.32292 10.6354 6.59375 10.9062C6.86458 11.1771 7 11.5417 7 12V13.5C7 13.9583 6.86458 14.3229 6.59375 14.5938C6.32292 14.8646 5.95833 15 5.5 15H4.5ZM9.5 15C9.04167 15 8.67708 14.8646 8.40625 14.5938C8.13542 14.3229 8 13.9583 8 13.5V12C8 11.5417 8.13542 11.1771 8.40625 10.9062C8.67708 10.6354 9.04167 10.5 9.5 10.5H10.5C10.9583 10.5 11.3229 10.6354 11.5938 10.9062C11.8646 11.1771 12 11.5417 12 12V13.5C12 13.9583 11.8646 14.3229 11.5938 14.5938C11.3229 14.8646 10.9583 15 10.5 15H9.5ZM14.5 15C14.0417 15 13.6771 14.8646 13.4062 14.5938C13.1354 14.3229 13 13.9583 13 13.5V12C13 11.5417 13.1354 11.1771 13.4062 10.9062C13.6771 10.6354 14.0417 10.5 14.5 10.5H15.5C15.9583 10.5 16.3229 10.6354 16.5938 10.9062C16.8646 11.1771 17 11.5417 17 12V13.5C17 13.9583 16.8646 14.3229 16.5938 14.5938C16.3229 14.8646 15.9583 15 15.5 15H14.5Z"
                            fill="black" />
                    </svg>
                    <span>Export Galley Proof</span>
                </button>
                <button *ngIf="!readOnlyMode" appAuthorizeControl="edit||offermang" type="button" mat-menu-item
                    [matMenuTriggerFor]="bulkEdit"><mat-icon>edit</mat-icon>Bulk Edit</button>
                <!-- <button type="button" mat-menu-item><mat-icon>file_copy</mat-icon>Copy</button> -->
                <mat-menu #bulkEdit="matMenu" class="mat_bulkedit">
                    <button type="button" mat-menu-item (click)="openEditPageDialog()"><mat-icon>print</mat-icon>Edit
                        Page</button>
                    <button type="button" mat-menu-item
                        (click)="openofferTagsDialog()"><mat-icon>local_offer</mat-icon>Edit Offer Tags</button>
                    <button type="button" mat-menu-item
                        (click)="openVersionsDialog('add')"><mat-icon>library_add</mat-icon>Add Versions</button>
                    <button type="button" mat-menu-item
                        (click)="openVersionsDialog('remove')"><mat-icon>delete_sweep</mat-icon>Remove Versions</button>
                    <button type="button" mat-menu-item (click)="openEditDatesDialog()"><mat-icon>event</mat-icon>Edit
                        Dates</button>
                </mat-menu>
                <button *ngIf="!readOnlyMode" appAuthorizeControl="edit||offermang" type="button" mat-menu-item
                    [matMenuTriggerFor]="Select"><mat-icon>check_circle_outline</mat-icon>Status</button>
                <button *ngIf="!readOnlyMode" type="button" mat-menu-item appAuthorizeControl="edit||offermang"
                    (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
                <button type="button" mat-menu-item *ngIf="listViewState.listViewStateValue.selectedRecords.length > 0">
                    {{ listViewState.listViewStateValue.selectedRecords.length }} Selected
                </button>
            </mat-menu>
            <mat-menu #Download="matMenu">
                <button mat-menu-item (click)="downloadOffersJSON()">Offer JSON</button>
                <button mat-menu-item (click)="downloadPromosJSON()">Promo JSON</button>
                <button mat-menu-item (click)="downloadOfferGroupJSON()">Offer Group JSON</button>
                <button mat-menu-item (click)="downloadEventJSON()">Event JSON</button>
                <button mat-menu-item [matMenuTriggerFor]="CSV">CSV</button>
                <button mat-menu-item (click)="downloadCommentsCSV()">Comments</button>
            </mat-menu>
            <mat-menu #GalleyProof="matMenu">
                <button mat-menu-item (click)="exportGalleyProof()">Export All</button>
                <button mat-menu-item (click)="ExportSelectedGalleyProof()">Export Selected</button>
            </mat-menu>
            <mat-menu #CSV="matMenu">
                <button mat-menu-item (click)="downloadAllCSV()">Export All</button>
                <button mat-menu-item (click)="downloadSelectedCSV()">Export Selected</button>
            </mat-menu>
            <mat-menu #Select="matMenu">
                <button class="statusPending" mat-menu-item (click)="updateStatus(1)">Pending</button>
                <button class="statusApproved" mat-menu-item (click)="updateStatus(2)">Approve</button>
                <button class="statusSuppressed" mat-menu-item (click)="updateStatus(3)">Suppress</button>
            </mat-menu>

            <button *ngIf="!readOnlyMode" appAuthorizeControl="edit||offermang" type="button" mat-raised-button
                color="accent" matTooltip="Clone" (click)="openDialog()">
                Clone
            </button>

            <button type="button"
                mat-stroked-button [matMenuTriggerFor]="menu" matTooltip="Actions">
                <mat-icon>more_vert</mat-icon>Actions
            </button>

            <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput formControlName="search" type="text" (input)="onSearch($event)"
                    placeholder="Search Offers & Promos" #searchInput />
                <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <span class="menu-spacer"></span>

            <!--only display the sort by dropdown for the cards view(table view sorts on columns)-->

            <mat-button-toggle-group #group="matButtonToggleGroup" value={{viewModel.viewMode}} aria-label="View mode">
                <mat-button-toggle *ngIf="viewModel.viewMode === 'CARDS' || viewModel.viewMode === 'TABLE'" type="button" mat-raised-button
                    [matTooltip]="variantViewMode === 'expanded' ? 'Collapse variants' : 'Expand variants'"
                    [attr.aria-label]="variantViewMode === 'expanded' ? 'Collapse variants' : 'Expand variants'"
                    [attr.aria-pressed]="variantViewMode === 'compressed'"
                    (click)="toggleVariantView()">
                    <svg *ngIf="variantViewMode === 'expanded'" class="variant-view-icon"
                        xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="currentColor" aria-hidden="true">
                        <path d="m296-80-56-56 240-240 240 240-56 56-184-184L296-80Zm184-504L240-824l56-56 184 184 184-184 56 56-240 240Z"/>
                    </svg>
                    <svg *ngIf="variantViewMode !== 'expanded'" class="variant-view-icon"
                        xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="currentColor" aria-hidden="true">
                        <path d="M160-80v-80h640v80H160Zm320-120L320-360l56-56 64 62v-252l-64 62-56-56 160-160 160 160-56 56-64-62v252l64-62 56 56-160 160ZM160-800v-80h640v80H160Z"/>
                    </svg>
                </mat-button-toggle>
                <mat-button-toggle value="CARDS" *ngIf="viewModel.viewMode === 'TABLE'" matTooltip="Card view"
                    aria-label="Card view" (click)="toggleView('CARDS')">
                    <mat-icon>grid_view</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="TABLE" *ngIf="viewModel.viewMode === 'CARDS'" matTooltip="Table view"
                    aria-label="Table view" (click)="toggleView('TABLE')">
                    <mat-icon>table_view</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle type="button" mat-raised-button matTooltip="Sort" (click)="onSort()">
                    <mat-icon>arrow_upward</mat-icon>
                </mat-button-toggle>

                <mat-button-toggle #filterToggleButton type="button" mat-raised-button matTooltip="Show/hide filters"
                    (click)="filterSidenav.toggle()">
                    <mat-icon>filter_alt</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>


        </div>

        <mat-sidenav-container>
            <!--filter sidenav-->
            <mat-sidenav #filterSidenav mode="over" position="end" class="pr1-filter-mat-sidenav">
                <mat-toolbar>
                    Filter
                    <span class="menu-spacer"></span>
                    <button type="button" mat-icon-button aria-label="Close filter menu" matTooltip="Close filter menu"
                        (click)="filterSidenav.toggle()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-toolbar>
                <div style="margin: 16px">
                    <div fxLayout="column">

                        <mat-form-field appearance="outline">
                            <mat-label>Versions</mat-label>
                            <mat-select formControlName="versions" multiple (selectionChange)="onFilterChange($event)"
                                [compareWith]="compareWithIdFn">
                                <mat-option *ngFor="let version of viewModel.versions" [value]="version">
                                    {{version.VersionName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Offer tags</mat-label>
                            <mat-select formControlName="offerTags" multiple (selectionChange)="onFilterChange($event)"
                                [compareWith]="compareWithTagIdFn">
                                <mat-option *ngFor="let tag of offerTagsListwithCount" [value]="tag">
                                    {{tag.TagName}} ({{tag.Count}})
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Offer + Promos</mat-label>
                            <mat-select formControlName="offerPromos" multiple
                                (selectionChange)="onFilterChange($event)" [compareWith]="compareWithValFn">
                                <mat-option *ngFor="let offerPromos of offerpromos" [value]="offerPromos">
                                    {{offerPromos.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Offer Status</mat-label>
                            <mat-select formControlName="offerStatus" multiple
                                (selectionChange)="onFilterChange($event)" [compareWith]="compareWithValFn">
                                <mat-option *ngFor="let status of offerstatus" [value]="status">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Page</mat-label>
                            <mat-select formControlName="page" multiple (selectionChange)="onFilterChange($event)">
                                <mat-option *ngFor="let item of printPagesList" [value]="item.Id">
                                    {{ item.PageFrom }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Categories</mat-label>
                            <mat-select formControlName="categories" multiple (selectionChange)="onFilterChange($event)"
                                [compareWith]="compareWithIdFn">
                                <mat-option *ngFor="let categorie of categoriesList" [value]="categorie">
                                    {{categorie.ProductCategoryName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <ng-container *ngIf="filtersForm.controls['withComments'].value">
                            <mat-form-field appearance="outline">
                                <mat-label>Comments</mat-label>
                                <mat-select formControlName="commentStatuses" multiple
                                    (selectionChange)="onFilterChange($event)">
                                    <mat-option *ngFor="let status of commentStatus"
                                        [value]="status">{{status}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Workflow Stages</mat-label>
                                <mat-select formControlName="workflowStages" [compareWith]="compareWithValFn" multiple
                                    (selectionChange)="onFilterChange($event)">
                                    <mat-option *ngFor="let workflowStage of viewModel.workflowStages"
                                        [value]="workflowStage">
                                        {{workflowStage.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>


                        <mat-checkbox class="pr-check-box" (change)="noTags($event)" formControlName="noTags">
                            Offers with no Offer Tag
                        </mat-checkbox>
                        <mat-checkbox class="pr-check-box" (change)="withComments($event)"
                            formControlName="withComments" *ngIf="showComments">
                            Offers with Comments
                        </mat-checkbox>

                        <mat-checkbox class="pr-check-box" (change)="withVariants($event)"
                            formControlName="withVariants">
                            Offers with Variants
                        </mat-checkbox>

                        <mat-checkbox class="pr-check-box" (change)="noVersions($event)"
                            formControlName="noVersions">
                            Offers with no Versions
                        </mat-checkbox>

                        <mat-checkbox class="pr-check-box" (change)="withTranslation($event)"
                            formControlName="withTranslation">
                            Translation
                        </mat-checkbox>

                    </div>
                    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
                        <button type="button" mat-storked-button matTooltip="Reset filters" (click)="resetFilters()">
                            Reset
                        </button>
                        <button type="button" mat-raised-button matTooltip="Apply filters" color="accent"
                            (click)="filterSidenav.toggle()" [disabled]="filtersForm.invalid">
                            Apply
                        </button>
                    </div>
                </div>

            </mat-sidenav>

            <!--main content-->
            <mat-sidenav-content #scrollContent>
                <!--filter chips -->
                <div class="filter-chips" *ngIf="viewModel.filters && viewModel.filters.length > 0" fxLayout="row">
                    <mat-chip-set aria-label="Selected filters">
                        <mat-chip *ngFor="let filter of viewModel.filters" (removed)="removeFilter(filter)">
                            {{filter.displayText}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <button type="button" class="filter_close_btn" mat-flat-button matTooltip="Remove all filters"
                            (click)="clearFilters()">
                            Clear all
                        </button>
                    </mat-chip-set>

                </div>

                <div class="show-changes-toggle" *ngIf="awDetails != null && activeStageIndex >= 2" fxLayout="row" fxLayoutAlign="start center">
                    <mat-slide-toggle
                        [checked]="showChangesFromPreviousStep"
                        (change)="onShowChangesFromPreviousStepChange($event.checked)"
                        aria-label="Show Changes from Previous Step">
                        Show Changes from Previous Step
                    </mat-slide-toggle>
                </div>

                <app-offer-list-cards #offerPromoCards *ngIf="viewModel.viewMode === 'CARDS'"
                    (contentRendered)="onContentRendered()" (viewSelected)="openSelectedRecordsDialog()" [variantViewMode]="variantViewMode"
                    [readOnly]="readOnlyMode"
                    [modifiedItems]="showChangesFromPreviousStep ? modifiedItems : []"></app-offer-list-cards>

                <app-offer-list-table #offerPromoTable *ngIf="viewModel.viewMode === 'TABLE'"
                    (contentRendered)="onContentRendered()" (viewSelected)="openSelectedRecordsDialog()" [variantViewMode]="variantViewMode"
                    [readOnly]="readOnlyMode"></app-offer-list-table>

                <mat-paginator *ngIf="viewModel.eventOfferTypes.length > 0" [length]="viewModel?.totalRecords"
                    [pageSize]="viewModel?.page?.pageSize" [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
                    (page)="onPage($event)" showFirstLastButtons [pageIndex]="viewModel?.page?.pageIndex">
                </mat-paginator>
            </mat-sidenav-content>

        </mat-sidenav-container>

    </form>

</ng-container>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
